// Map type to regex test variations, used to exract the video id from url
const typeRegexMap = {
	Vimeo: [
		/\/vimeo\.com\/([^/]+)/,
		/player\.vimeo\.com\/video\/([^/]+)/
	],
	YouTube: [
		/youtu\.be\/([^/]+)/,
		/watch\?v=([^&]+)/,
		/youtube\.com\/embed\/([^/]+)/,
		/youtube\.com\/v\/([^/]+)/
	]
};

// Map type to a template function that returns the embed url
const urlTemplateMap = {
	Vimeo: videoId => `https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&autoplay=1`,
	YouTube: videoId => `https://www.youtube-nocookie.com/embed/${videoId}?modestbranding=1&rel=0&iv_load_policy=3&color=white&autoplay=1`
};

// Helper method to extract the video id from the url
const getVideoId = (videoUrl, type) => {
	const tests = typeRegexMap[type] || [];

	for (let test of tests) {
		const [, videoId] = videoUrl.match(test) || [];

		if (videoId) {
			return videoId;
		}
	}

	return null;
};

/**
 * Parse a video URL and return it's iframe embed URL.
 * @param {string} videoUrl The embed or video URL.
 * @param {'YouTube'|'Vimeo'} type The type of video URL.
 * @returns {string|null} The URL needed to iframe/embed the video.
 */
export const convertVideoUrlToEmbedUrl = (videoUrl, type) => {
	// Get template function
	const template = urlTemplateMap[type];
	if (!template) {
		return null;
	}

	// Get video id from url
	const videoId = getVideoId(videoUrl, type);
	if (!videoId) {
		return null;
	}

	return template(videoId);
};

/**
 * Parse a video URL and return it's thumbnail url.
 * @see https://vumbnail.com
 * @param {string} videoUrl The embed or video URL.
 * @param {'YouTube'|'Vimeo'} type The type of video URL.
 * @returns {string|null} The URL to it's thumbnail.
 */
export const convertVideoUrlToThumbnailUrl = (videoUrl, type, size = 'small') => {
	// Get video id from url
	const videoId = getVideoId(videoUrl, type);
	if (!videoId) {
		return null;
	}

	return `https://vumbnail.com/${videoId}_${size}.jpg`;
};
